export default __webpack_public_path__ + "static/media/CCS_cloudxier2.b0bcfdf8.png";